import React from "react";
import { VideoPlayer } from "@ecommo/r2player";

export function OutterVideoPlayer({ r2pData, playerSocket, showLabel }) {
    if (!r2pData.PlayerSocket) {
        r2pData.PlayerSocket = playerSocket;
    }
    /*const enhancedData = {
        ...r2pData,
        PlayerSocket: playerSocket
    };*/
    return (
        <div style={{ width: `${r2pData.width}px`, textAlign: "center" }}>
            <VideoPlayer r2pData={r2pData} />
            {showLabel && (
                <div style={{ marginTop: "8px", fontSize: "14px", fontWeight: "bold", color: "#444", fontFamily: "Arial, sans-serif" }}>
                    {r2pData.productDescription}
                </div>
            )}
        </div>
    );
}
